import { Component } from '@angular/core';

@Component({
    selector: 'app-negociacao-coletiva-simplificada-bloqueio-assinatura',
    templateUrl: './bloqueio-assinatura.component.html',
    styleUrls: ['./bloqueio-assinatura.component.css']
})

export class NegociacaoColetivaSimplificadaBloqueioAssinaturaComponent {
}
